import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Confirm,
  Divider,
  Icon,
  Image,
  Modal,
  Dimmer,
  Loader,
  Segment,
  Menu,
  MenuItem,
  Sticky
} from "semantic-ui-react";
import ReactTable from "react-table";
import request from "../../utils/request";
import { apiUrl } from "../../utils/constants"
import matchSorter from 'match-sorter';

const unitTabs = {
  activeUnits: 1,
  archivedUnits: 2
}

class DeviceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: true,
      sorted: [{ id: "id", desc: false }],
      data: [],
      query: "",
      pageSize: 20,
      page: 0,
      pages: -1,
      resized: [],
      filtered: [],
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: "",
      open: false,
      activeItem: unitTabs.activeUnits
    };
    this.fetchData = this.fetchData.bind(this);
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
  };
  display = size => () => this.setState({ size, open: true, active: true });
  close = () => this.setState({ open: false }, this.fetchData);
  loader = () => this.setState({ active: false });
  fetchData = () => {
    this.setState({ isLoading: true });
    request
      .get(this, "api:/device", {
        sort: this.state.sorted,
        q: this.state.query,
        page: this.state.page + 1,
        limit: 0,
        filterUnits: this.state.activeItem,
        ts: Date.now()
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,
          pages: Math.ceil(resp.total / this.state.pageSize)
        });
      });
  };
  handleChange = (e, { name, value }) => {
    this.setState({ query: value });
  };
  showConfirm = (id, title) => {
    this.setState({ confirmOpen: true, confirmId: id, confirmTitle: title });
  };
  handleConfirm = () => {
    if (this.state.confirmId === "activate") {
      this.activateDevice();
    } else {
      if (this.state.activeItem == 1) {
        this.deleteDevice();
      } else {
        this.restoreDevice();
      }
      
    }
  };
  handleCancel = () => {
    this.setState({
      result: "cancelled",
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
  };
  activateDevice = deviceId => {
    let payload = { active: 1 };
    if (typeof deviceId !== "undefined") {
      payload = { id: deviceId };
    }
    this.setState({
      isLoading: true,
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
    return request.put(this, "api:/device/activate", payload).then(resp => {
      this.setState({
        isLoading: false
      });
      return this.fetchData();
    });
  };
  restoreDevice = () => {
    let payload = { deviceId: this.state.confirmId };
    this.setState({
      isLoading: true,
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
    return request.post(this, "api:/device/restore", payload).then(resp => {
      this.setState({
        isLoading: false
      });
      return this.fetchData();
    });
  };
  deleteDevice = () => {
    this.setState({
      isLoading: true,
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
    return request.delete(this, `api:/device/${this.state.confirmId}`).then(resp => {
      this.setState({
        isLoading: false
      });
      return this.fetchData();
    });
  };
  handleUnitsMenuClick = (e, activeTab) => {
    this.setState({ activeItem: activeTab }, () => {
      this.fetchData();
    })
  }

  render() {
    const {
      data,
      isLoading,
      confirmOpen,
      confirmTitle,
      open,
      size,
      active,
      activeItem
    } = this.state;
    const columns = [
      {
        Header: "Active",
        id: "active",
        accessor: d => (
          <Button.Group>
            <Button
              type="button"
              icon="power"
              color={d.active === 1 ? "green" : "red"}
              onClick={() => this.activateDevice(d.id)}
            />
            <Button
              type="button"
              as={Link}
              to={`/devices/${d.id}/edit`}
              primary
              icon="edit"
            />
            {activeItem == 1 && <Button
              color="red"
              type="button"
              onClick={() => this.showConfirm(d.id, `Are you sure your want to delete ${d.name}?`)}
              icon="trash"
            />}
            {activeItem == 2 && <Button
              color="green"
              type="button"
              onClick={() => this.showConfirm(d.id, `Are you sure your want to restore ${d.name}?`)}
              icon="undo"
            />}
          </Button.Group>
        ),
        filterable: false,
        width: 200
      },
      {
        Header: "Name",
        id: "name",
        accessor: d => (
          +d.is_new === 1 ? <em>Unregistered Device</em> : d.name
        ),
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["name"] }),
        filterAll: true
      },
      {
        Header: "CC",
        id: "accept_credit",
        accessor: d => (
          <Icon
            name={+d.accept_credit === 1 ? "check" : "close"}
            color={+d.accept_credit === 1 ? "green" : "red"}
          />
        ),
        filterable: false,
        width: 200
      },
      {
        Header: "Cash",
        id: "accept_cash",
        accessor: d => (
          <Icon
            name={+d.accept_cash === 1 ? "check" : "close"}
            color={+d.accept_cash === 1 ? "green" : "red"}
          />
        ),
        filterable: false,
        width: 200
      },
      {
        Header: "Reg.",
        id: "is_new",
        accessor: d => (
          <Icon
            name={+d.is_new === 0 ? "check" : "close"}
            color={+d.is_new === 0 ? "green" : "red"}
          />
        ),
        filterable: false,
        width: 200
      },
      {
        Header: "ID",
        accessor: "id",
        filterable: false,
        width: 200
      }
    ];
    return (
      <Segment basic className="DeviceListSegment">
        <Confirm
          open={confirmOpen}
          content={confirmTitle}
          cancelButton="Cancel"
          confirmButton="Confirm"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
        <Menu secondary stackable id="div_search_devices">
          <Menu.Menu position='right'>
            <Menu.Item className="btn_devices_grp">
              <Button
                as={Link}
                to={"/devices/create"}
                icon="tablet"
                content="New device"
                primary
                fluid
              />
            </Menu.Item>
            <Menu.Item className="btn_devices_grp">
              <Button
                fluid
                onClick={() =>
                  this.showConfirm(
                    "activate",
                    "Are you sure you want to activate all devices?"
                  )
                }
                icon="power"
                content="Activate all"
                color="green"
              />
            </Menu.Item>
            <Menu.Item className="btn_devices_grp">
              <Modal
                trigger={
                  <Button
                    secondary
                    icon="refresh"
                    content="Initialize"
                    onClick={this.display("mini")}
                    className="btn_devices_grp"
                  />
                }
                closeIcon
                onClose={this.close}
                open={open}
                size={size}
              >
              <Modal.Content>
                <Dimmer active={active} inverted>
                  <Loader>Loading</Loader>
                </Dimmer>
                  <Image src={apiUrl() + "/device/initialize"} onLoad={this.loader} />
              </Modal.Content>
              <Modal.Actions>
                <Button onClick={this.close}>Close</Button>
              </Modal.Actions>
              </Modal>
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Divider hidden />
        <Sticky>
          <Menu color='orange' pointing stackable>
            <MenuItem name="activeDraws" active={activeItem == unitTabs.activeUnits} onClick={(e) => { this.handleUnitsMenuClick(e, unitTabs.activeUnits) }}>
              <Icon name='calendar check' color='green' />
              Active Units
            </MenuItem>
            <MenuItem name="archivedDraws" active={activeItem == unitTabs.archivedUnits} onClick={(e) => { this.handleUnitsMenuClick(e, unitTabs.archivedUnits) }}>
                <Icon color='red' name='archive' />
                Archived Units
            </MenuItem>
          </Menu>
        </Sticky>
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it
          resizable
          filterable
          defaultPageSize={20}
          minRows={0}
        />
      </Segment>
    );
  }
}

export default DeviceList;
